/* @flow */

import type { Question, QuestionType } from '../types';

export const QUESTION_ADDED: string = 'survey@QUESTION_ADDED';
export const QUESTION_UPDATED: string = 'survey@QUESTION_UPDATED';
export const QUESTION_TYPE_CHANGED: string = 'survey@QUESTION_TYPE_CHANGED';
export const QUESTION_ORDER_CHANGED: string = 'survey@QUESTION_ORDER_CHANGED';
export const QUESTION_DELETED: string = 'survey@QUESTION_DELETED';

export const addQuestion = () => ({
  type: QUESTION_ADDED,
});

export const updateQuestion = (question: Question) => ({
  type: QUESTION_UPDATED,
  question,
});

export const changeQuestionType = (question: Question, type: QuestionType) => ({
  type: QUESTION_TYPE_CHANGED,
  question,
  questionType: type,
});

export const changeQuestionOrder = (question: Question, order: number) => ({
  type: QUESTION_ORDER_CHANGED,
  question,
  order,
});

export const deleteQuestion = (question: Question) => ({
  type: QUESTION_DELETED,
  question,
});



// WEBPACK FOOTER //
// ./src/modules/survey/actions/questions.js